import React, { useState, useEffect } from "react";
import SearchIcon from "@mui/icons-material/SearchTwoTone";
import { InputGroup, Button, FormControl, Col, Accordion, Card, Row, Spinner, Modal, Dropdown } from "react-bootstrap";
import _ from "lodash";
import ApiBasketItemPerson from "../../../../core/api/api.basketItemPerson";
import ApiSupplier from "../../../../core/api/api.supplier";
import { FormProvider, useForm, Controller } from "react-hook-form";
import DataGrid from "./DataGrid";
import { useNavigate, useLocation } from "react-router-dom";
import { tools } from "../../../../core/utils/tools";
import ApiAmusementService from "../../../../core/api/api.amusementService";
import ShamsiDatePicker from "../../_Components/ShamsiDatePicker";
import SwalMessage from "../../_Components/SwalMessage";
import ApiOrdersService from "../../../../core/api/api.ordersService";
import ApiAmusementServiceReserveItem from "../../../../core/api/api.amusementServiceReserveItem";
import ApiAmusementServiceReserveItemGroup from "../../../../core/api/api.amusementServiceReserveItemGroup";
import { TextField } from "@mui/material";
import { NumericFormat } from "react-number-format";
import SelectComponent from "../../_Components/ReactSelectComponent";
import ApiHome from "../../../../core/api/api.home";
import InsertDriveFile from "@mui/icons-material/InsertDriveFile";
import ApiAmusementGroup from "../../../../core/api/api.amusementGroup";
import ApiAgent from "../../../../core/api/api.agent";
import GlobalFormControl from "../../_Components/GlobalFormControl";
import ApiRegion from "../../../../core/api/api.region";

const receiveOrPayToWarrantyEnumArray = [
  { id: "", title: "-----" },
  { id: "1", title: "دارد" },
  { id: "0", title: "ندارد" },
  { id: "2", title: "بیشتر از یکی" },
];

const promoCodeEnumArray = [
  { id: "", title: "-----" },
  { id: "1", title: "دارد" },
  { id: "0", title: "ندارد" },
];

const sortOptions = [{ label: "پیش فرض", value: 1 }, { label: "تاریخ استفاده تفریح", value: 2 }]

const SellReport = () => {
  const navigate = useNavigate();
  const location = useLocation();
  const searchParams = new URLSearchParams(location.search);
  const [listData, setListData] = useState({});
  const [services, setServices] = useState([]);
  const [basketItemCurrentStatus, setBasketItemCurrentStatus] = useState([]);
  const [basketCancelStatus, setBasketCancelStatus] = useState([]);
  const [suppliers, setSuppliers] = useState();
  const [commissionSettlementStatus, setCommissionSettlementStatus] = useState([]);
  const [isExcel, setIsExcel] = useState(false);

  const {
    register,
    handleSubmit,
    control,
    formState: { errors, isSubmitting },
    getValues,
    setValue,
    watch,
    reset,
    setError,
    clearErrors,
  } = useForm();

  const methods = { register, handleSubmit, control, formState: { errors, isSubmitting }, getValues, setValue, watch };
  const pageSizeFromUrl1 = searchParams.get("pageSize");
  const pageSizeFromUrl = !_.isEmpty(pageSizeFromUrl1) ? _.toNumber(pageSizeFromUrl1) : 10;
  const pageNumberFromUrl1 = searchParams.get("pageNumber");
  const pageNumberFromUrl = !_.isEmpty(pageNumberFromUrl1) ? _.toNumber(pageNumberFromUrl1) : 1;
  const [groupedReserveItemsOptions, setGroupedReserveItemsOptions] = useState([]);
  const [group, setGroup] = useState([]);
  const [amusementGroupList, setAmusementGroupList] = useState([]);
  const [amusementCityList, setAmusementCityList] = useState([]);
  const [isSelectOtherCityElseKish, setIsSelectOtherCityElseKish] = useState(false)
  const sortBy1 = searchParams.get("sortBy");
  const sortBy = !_.isEmpty(sortBy1) ? _.toNumber(sortBy1) : 1;
  const [agents, setAgents] = useState([]);

  useEffect(() => {
    (async () => {
      try {
        const data = await ApiBasketItemPerson.getBasketItemPersonsReport({
          pageSize: !_.isEmpty(pageSizeFromUrl) ? getValues("pageSize") : pageSizeFromUrl,
          pageNumber: !_.isEmpty(pageNumberFromUrl) ? getValues("pageNumber") : pageNumberFromUrl,
          useTimeOf: searchParams.get("useTimeOf"),
          useTimeTo: searchParams.get("useTimeTo"),
          createTimeOf: searchParams.get("createTimeOf"),
          createTimeTo: searchParams.get("createTimeTo"),
          cancelStatus: _.toString(searchParams.get("cancelStatus")),
          currentStatus: _.toString(searchParams.get("currentStatus")),
          cityIdList: searchParams.get("cityIdList"),
          groupIdList: searchParams.get("groupIdList"),
          amusementServiceIds: searchParams.get("amusementServiceIds"),
          amusementServiceReserveItemIds: searchParams.get("amusementServiceReserveItemIds"),
          amusementServiceReserveItemGroupIds: searchParams.get("amusementServiceReserveItemGroupIds"),
          originalPrice: searchParams.get("originalPrice"),
          salePrice: searchParams.get("salePrice"),
          firstName: searchParams.get("firstName"),
          lastName: searchParams.get("lastName"),
          phoneNumber: searchParams.get("phoneNumber"),
          basketItemPersonOf: searchParams.get("basketItemPersonOf"),
          basketItemPersonTo: searchParams.get("basketItemPersonTo"),
          basketIdOf: searchParams.get("basketIdOf"),
          basketIdTo: searchParams.get("basketIdTo"),
          payOrReceiveWarrantyTimeOf: searchParams.get("payOrReceiveWarrantyTimeOf"),
          payOrReceiveWarrantyTimeTo: searchParams.get("payOrReceiveWarrantyTimeTo"),
          promoCode: searchParams.get("promoCode"),
          globalSearch: searchParams.get("globalSearch"),
          receiveFromWarrantyCount: searchParams.get("receiveFromWarrantyCount"),
          payToWarrantyCount: searchParams.get("payToWarrantyCount"),
          supplierIdList: searchParams.get("supplierIdList"),
          transactionSupplierIdList: searchParams.get("transactionSupplierIdList"),
          sortBy,
          commissionSettlementStatus: searchParams.get("commissionSettlementStatus"),
          agentId: searchParams.get("agentId"),
          supplierIdList: searchParams.get("supplierIdList")
        });
        setValue("sortBy", sortOptions.find(item => item.value == sortBy))
        setListData(data);
        if (!data.succeeded) {
          SwalMessage({
            title: data.message,
            iSsuccess: false,
            timer: 4000,
          });
          return;
        }
        setValue("totalCount", data.totalCount);
        const amusementService = await ApiAmusementService.getAllServices();
        setServices(amusementService);

        const suppliers = await ApiSupplier.getAllSuppliersName();
        setSuppliers(suppliers);
        const resultBasketItemCurrentStatus = await ApiOrdersService.GetEnumsName("BasketItemCurrentStatus");
        setBasketItemCurrentStatus(resultBasketItemCurrentStatus.data);

        const resultBasketCancelStatus = await ApiOrdersService.GetEnumsName("BasketCancelStatus");
        setBasketCancelStatus(resultBasketCancelStatus.data);

        const commissionSettlementStatusList = await ApiHome.getEnums({ enumName: "CommissionSettlementStatus" });
        if (commissionSettlementStatusList.succeeded) {
          const CommissionSettlementArray = commissionSettlementStatusList?.data?.map((item) => ({
            value: item.value,
            label: item.title,
          }));
          setCommissionSettlementStatus([{ value: undefined, label: "-------" }, ...CommissionSettlementArray]);
        }
        const amusementGroups = await ApiAmusementGroup.getAll({ pageSize: 200, pageNumber: 1 });
        setAmusementGroupList(amusementGroups.data);
        const cities = await ApiRegion.getAllCity();
        const kish = cities.filter(city => city.name == 'کیش').map((item) => ({
          value: item.id,
          label: item.id + "-" + item.name,
        }))
        const otherCities = cities.filter(city => city.name != 'کیش' && city.id != 0).map((item) => ({
          value: item.id,
          label: item.id + "-" + item.name,
        }))
        setAmusementCityList([
          {
            label: 'شهر های مورد علاقه',
            options: [...kish, { label: "سایر شهرها به جز کیش", value: 0 }]
          },
          {
            label: "همه شهر های ایران",
            options: otherCities
          }
        ]);
        const agentsResponse = await ApiAgent.getAllAgentsName();
        setAgents(agentsResponse);
        const amusementItemIds = searchParams.get("amusementServiceIds")?.split(",") || [];

        const selectedServiceIds = amusementService
          .filter((item) => amusementItemIds.includes(String(item.id)))
          ?.map((item) => ({ label: item.name, value: item.id }));

        const selectedItemsGroupIds = searchParams.get("amusementServiceReserveItemGroupIds")?.split(",") || [];

        const selectedItemsItemIds = searchParams.get("amusementServiceReserveItemIds")?.split(",") || [];

        inputChangeHandlerService(selectedServiceIds, true, selectedItemsGroupIds, selectedItemsItemIds);
        const mergedGroupedReserveItemsOptions = groupedReserveItemsOptions.map((item) => item.options).flat();

        const formInputs = [
          { name: "originalPrice", type: "text" },
          { name: "salePrice", type: "text" },
          { name: "useTimeOf", type: "datePicker" },
          { name: "useTimeTo", type: "datePicker" },
          { name: "createTimeOf", type: "datePicker" },
          { name: "createTimeTo", type: "datePicker" },
          { name: "firstName", type: "text" },
          { name: "lastName", type: "text" },
          { name: "phoneNumber", type: "text" },
          { name: "basketItemPersonOf", type: "text" },
          { name: "basketItemPersonTo", type: "text" },
          { name: "basketIdOf", type: "text" },
          { name: "basketIdTo", type: "text" },
          { name: "payOrReceiveWarrantyTimeOf", type: "datePicker" },
          { name: "payOrReceiveWarrantyTimeTo", type: "datePicker" },

          { name: "promoCode", type: "multiSelect", isMulti: false, data: promoCodeEnumArray },
          { name: "currentStatus", type: "multiSelect", isMulti: true, data: resultBasketItemCurrentStatus.data },
          { name: "cityIdList", type: "multiSelect", isMulti: true, data: cities },
          { name: "groupIdList", type: "multiSelect", isMulti: true, data: amusementGroups.data },
          {
            name: "amusementServiceReserveItemGroupIds",
            type: "multiSelect",
            isMulti: true,
            data: mergedGroupedReserveItemsOptions?.map((optionItem) => ({
              id: optionItem.value,
              title: optionItem.label,
            })),
          },
          { name: "cancelStatus", type: "multiSelect", isMulti: true, data: resultBasketCancelStatus.data },
          { name: "globalSearch", type: "text" },
          { name: "pageSize", type: "number" },
          { name: "pageNumber", type: "number" },
          { name: "receiveFromWarrantyCount", type: "multiSelect", isMulti: false, data: receiveOrPayToWarrantyEnumArray },
          { name: "payToWarrantyCount", type: "multiSelect", isMulti: false, data: receiveOrPayToWarrantyEnumArray },
          {
            name: "supplierIdList",
            type: "multiSelect",
            isMulti: true,
            data: suppliers?.map((item) => ({
              id: item.id,
              title: item.companyName,
            })),
          },
          {
            name: "transactionSupplierIdList",
            type: "multiSelect",
            isMulti: true,
            data: suppliers?.map((item) => ({
              id: item.id,
              title: item.companyName,
            })),
          },
          {
            name: "sortBy",
            type: "multiSelect",
            isMulti: false,
            data: sortOptions,
          },
          {
            name: "commissionSettlementStatus",
            type: "multiSelect",
            isMulti: false,
            data: commissionSettlementStatusList?.data?.map((item) => ({ id: item.value, title: item.title })),
          },
          { name: "amusementServiceIds", type: "multiSelect", isMulti: true, data: amusementService },
          {
            name: "agentId", type: "multiSelect", isMulti: false, data: agentsResponse?.data?.map((item) => ({
              id: item.id,
              title: item.companyName,
            })),
          },
        ];

        tools.setInputsValues_ReactHookFrom(setValue, searchParams, formInputs);
      } catch (error) {
      } finally {
      }
    })();

    return () => { };
  }, []);
  useEffect(() => {
    setAmusementCityList(prev => {
      const otherCities = prev[1]?.options
      const cities = prev[0]?.options
      const disabledOtherCities = otherCities?.map(city => ({ ...city, isDisabled: isSelectOtherCityElseKish })) || []
      const disabledCities = cities?.map(city => ({ ...city, isDisabled: isSelectOtherCityElseKish })) || []

      return [{ ...prev[0], options: disabledCities }, { ...prev[1], options: disabledOtherCities }]
    })

  }, [getValues("cityIdList")])

  const inputChangeHandlerService = async (
    event,
    firstRender = false,
    selectedItemsGroupIds = [],
    selectedItemsItemIds = []
  ) => {
    if (!firstRender) setValue("amusementServiceIds", event);

    if (event.length > 0) {
      const responses = await Promise.all(
        event.map(async ({ value }) => {
          const reserveItems = await ApiAmusementServiceReserveItem.getAllReserveItems(value);
          const reserveItemGroups = await ApiAmusementServiceReserveItemGroup.getAllReserveItemGroups(value);
          return [reserveItems, reserveItemGroups, value];
        })
      );

      let groupedReserveItemsOptions = [];
      let groupedReserveItemGroupOptions = [];
      let itemList = [];
      let groupList = [];

      responses.forEach(([reserveItems, reserveItemGroups, value]) => {
        const label = event.find((item) => item.value == value)?.label;

        const optionsItems = reserveItems.map((item) => ({
          value: item.id,
          label: item.title,
        }));

        const optionsGroups = reserveItemGroups.map((item) => ({
          value: item.id,
          label: item.title,
        }));

        groupedReserveItemsOptions.push({ label, options: optionsGroups }); // گروه آیتم‌ها
        groupedReserveItemGroupOptions.push({ label, options: optionsItems }); // آیتم‌ها

        if (firstRender) {
          const selectedGroupItems = reserveItemGroups
            .filter((item) => selectedItemsGroupIds.includes(String(item.id)))
            .map((item) => ({ value: item.id, label: item.title }));

          const selectedItems = reserveItems
            .filter((item) => selectedItemsItemIds.includes(String(item.id)))
            .map((item) => ({ value: item.id, label: item.title }));

          itemList.push(...selectedGroupItems);
          groupList.push(...selectedItems);
        }
      });
      setGroupedReserveItemsOptions(groupedReserveItemsOptions);
      setGroup(groupedReserveItemGroupOptions);

      if (firstRender) {
        setValue("amusementServiceReserveItemGroupIds", itemList);
        setValue("amusementServiceReserveItemIds", groupList);
      }
    } else if (event.length === 0) {
      // وقتی هیچ تفریحی انتخاب نشده
      setGroupedReserveItemsOptions([]);
      setGroup([]);
      setValue("amusementServiceReserveItemGroupIds", []);
      setValue("amusementServiceReserveItemIds", []);
    }
  };

  const onSubmit = async (data) => {
    if (data.cityIdList?.length > 0) data.cityIdList = _.toString(data.cityIdList?.map((item) => item.value));
    if (data.groupIdList?.length > 0) data.groupIdList = _.toString(data.groupIdList?.map((item) => item.value));
    if (data.supplierIdList?.length > 0) data.supplierIdList = _.toString(data.supplierIdList?.map(supplier => supplier.value));
    if (data.transactionSupplierIdList?.length > 0) data.transactionSupplierIdList = _.toString(data.transactionSupplierIdList?.map(supplier => supplier.value));
    data.sortBy = data.sortBy?.value || 1;

    if (!_.isEmpty(data.originalPrice) && !validateNumberOriginalPrice(data.originalPrice)) return;
    if (!_.isEmpty(data.salePrice) && !validateNumberSalePrice(data.salePrice)) return;
    if (!_.isEmpty(data.basketItemPersonOf) && !validateNumberBasketItemPersonOf(data.basketItemPersonOf)) return;
    if (!_.isEmpty(data.basketItemPersonTo) && !validateNumberBasketItemPersonTo(data.basketItemPersonTo)) return;
    if (!_.isEmpty(data.basketIdOf) && !validateNumberBasketIdOf(data.basketIdOf)) return;
    if (!_.isEmpty(data.basketIdTo) && !validateNumberBasketIdTo(data.basketIdTo)) return;

    data.promoCode = data.promoCode?.value;
    data.commissionSettlementStatus = data.commissionSettlementStatus?.value;
    data.payToWarrantyCount = data.payToWarrantyCount?.value;
    data.receiveFromWarrantyCount = data.receiveFromWarrantyCount?.value;

    if (data.cancelStatus?.length > 0) data.cancelStatus = _.toString(data.cancelStatus?.map((item) => item.value));
    if (data.currentStatus?.length > 0) data.currentStatus = _.toString(data.currentStatus?.map((item) => item.value));

    if (data.amusementServiceIds?.length > 0)
      data.amusementServiceIds = _.toString(data.amusementServiceIds?.map((item) => item.value));

    if (data.amusementServiceReserveItemGroupIds?.length > 0)
      data.amusementServiceReserveItemGroupIds = _.toString(
        data.amusementServiceReserveItemGroupIds?.map((item) => item.value),
      );

    if (data.amusementServiceReserveItemIds?.length > 0)
      data.amusementServiceReserveItemIds = _.toString(data.amusementServiceReserveItemIds?.map((item) => item.value));

    if (data.payOrReceiveWarrantyTimeOf !== null && typeof data.payOrReceiveWarrantyTimeOf === "object") {
      data.payOrReceiveWarrantyTimeOf = tools.DateFormat(data.payOrReceiveWarrantyTimeOf);
    }
    if (data.payOrReceiveWarrantyTimeTo !== null && typeof data.payOrReceiveWarrantyTimeTo === "object") {
      data.payOrReceiveWarrantyTimeTo = tools.DateFormat(data.payOrReceiveWarrantyTimeTo);
    }
    if (data.useTimeOf !== null && typeof data.useTimeOf === "object") {
      data.useTimeOf = tools.DateFormat(data.useTimeOf);
    }
    if (data.useTimeTo !== null && typeof data.useTimeTo === "object") {
      data.useTimeTo = tools.DateFormat(data.useTimeTo);
    }
    if (data.createTimeOf !== null && typeof data.createTimeOf === "object") {
      data.createTimeOf = tools.DateFormat(data.createTimeOf);
    }
    if (data.createTimeTo !== null && typeof data.createTimeTo === "object") {
      data.createTimeTo = tools.DateFormat(data.createTimeTo);
    }
    if (!_.isEmpty(data.salePrice)) data.salePrice = data.salePrice.replaceAll(",", "");
    if (!_.isEmpty(data.originalPrice)) data.originalPrice = data.originalPrice.replaceAll(",", "");
    data.agentId = _.toString(data.agentId?.value);

    tools.setPageNumber(data, searchParams, setValue);

    if (isExcel) {
      await ApiBasketItemPerson.getBasketItemPersonsReportByExcel(data).then((response) => {
        const fileBlobUrl = URL.createObjectURL(new Blob([response]));
        const anchor = document.createElement("a");
        anchor.style.display = "none";
        anchor.id = "file" + Math.floor(Math.random() * 100);
        anchor.href = fileBlobUrl;
        anchor.download = "Report.xlsx";
        document.body.appendChild(anchor);
        anchor.click();
      });
      setIsExcel(false);
    }
    const apiData = await ApiBasketItemPerson.getBasketItemPersonsReport(data);
    //ارسال داده های فرم به تابع پس از حذف آیتم های اضافه
    var queryString = tools.createQueryStringFromFromData(_.omit(data, ["totalPages", "totalCount"]));
    navigate(`/reportSell?${queryString}`);
    setListData(apiData);
    setValue("totalCount", apiData.totalCount);

  };

  function handleChangeMultiCurrentStatus(value) {
    setValue("currentStatus", value);
  }
  function handleChangeMultiCancelStatus(value) {
    setValue("cancelStatus", value);
  }

  const validateNumberOriginalPrice = (value) => {
    if (Number(value) > 2147483647 || value.includes(".") || value.includes("-")) {
      setError("originalPrice", { type: "manual", message: "عدد وارد شده باید مثبت و کمتر از 2,147,483,647 باشد." });
      return false;
    } else {
      clearErrors("originalPrice");
      return true;
    }
  };

  const validateNumberSalePrice = (value) => {
    if (Number(value) > 2147483647 || value.includes(".") || value.includes("-")) {
      setError("salePrice", { type: "manual", message: "عدد وارد شده باید مثبت و کمتر از 2,147,483,647 باشد." });
      return false;
    } else {
      clearErrors("salePrice");
      return true;
    }
  };

  const validateNumberBasketItemPersonOf = (value) => {
    if (Number(value) > 2147483647 || value.includes(".") || value.includes("-")) {
      setError("basketItemPersonOf", {
        type: "manual",
        message: "عدد وارد شده باید مثبت و کمتر از 2,147,483,647 باشد.",
      });
      return false;
    } else {
      clearErrors("basketItemPersonOf");
      return true;
    }
  };
  const validateNumberBasketItemPersonTo = (value) => {
    if (Number(value) > 2147483647 || value.includes(".") || value.includes("-")) {
      setError("basketItemPersonTo", {
        type: "manual",
        message: "عدد وارد شده باید مثبت و کمتر از 2,147,483,647 باشد.",
      });
      return false;
    } else {
      clearErrors("basketItemPersonTo");
      return true;
    }
  };

  const validateNumberBasketIdOf = (value) => {
    if (Number(value) > 2147483647 || value.includes(".") || value.includes("-")) {
      setError("basketIdOf", { type: "manual", message: "عدد وارد شده باید مثبت و کمتر از 2,147,483,647 باشد." });
      return false;
    } else {
      clearErrors("basketIdOf");
      return true;
    }
  };
  const validateNumberBasketIdTo = (value) => {
    if (Number(value) > 2147483647 || value.includes(".") || value.includes("-")) {
      setError("basketIdTo", { type: "manual", message: "عدد وارد شده باید مثبت و کمتر از 2,147,483,647 باشد." });
      return false;
    } else {
      clearErrors("basketIdTo");
      return true;
    }
  };

  return (
    <div>
      <div className={`card card-custom`}>
        <div className="card-header border-0 pb-3 pt-5">
          <h3 className="card-title align-items-start flex-column">
            <span className="card-label font-weight-bolder text-dark">گزارش فروش</span>
            <span className="text-muted mt-3 font-weight-bold font-size-sm">صورت معاملات دوره ای</span>
          </h3>
        </div>
        {/*Start body */}
        <div className="card-body pt-3 pb-0">
          <FormProvider {...methods}>
            <form id="form" onSubmit={methods.handleSubmit(onSubmit)}>
              {/* search box */}

              <div className="border-top pt-3">
                {/* {Serach} */}
                <Accordion>
                  <Card>
                    <Accordion.Header as={Card.Header} variant="link" eventKey="0">
                      <Card.Title className="py-0 pl-0 text-gray fs-normal">جستجو پیشرفته</Card.Title>
                    </Accordion.Header>
                    <Accordion.Body eventKey="0">
                      <Card.Body>
                        <Row>
                          <Col sm="6" xl="3" className="tb-responsive px-2 mb-1 mt-5">
                            <Controller
                              name="createTimeOf"
                              control={control}
                              render={({ field: { onChange, value } }) => {
                                return (
                                  <ShamsiDatePicker
                                    value={value}
                                    onChange={(date) => {
                                      var createTimeTo = getValues("createTimeTo");
                                      onChange(date);
                                      if (
                                        !createTimeTo ||
                                        (date?.toDate && date?.toDate()?.getTime() > new Date(createTimeTo).getTime())
                                      ) {
                                        // Set the value of createTimeTo to the same as createTimeTo
                                        setValue("createTimeTo", date);
                                      }
                                    }}
                                    placeholder="زمان ایجاد از"
                                  />
                                );
                              }}
                            />
                          </Col>
                          <Col sm="6" xl="3" className="px-2 mb-1 mt-5">
                            <Controller
                              name="createTimeTo"
                              control={control}
                              render={({ field: { onChange, value } }) => (
                                <ShamsiDatePicker value={value} onChange={onChange} placeholder="زمان ایجاد تا" />
                              )}
                            />
                          </Col>
                          <Col sm="6" xl="3" className="px-2 mb-1 mt-5">
                            <Controller
                              name="useTimeOf"
                              control={control}
                              render={({ field: { onChange, value } }) => (
                                <ShamsiDatePicker
                                  value={value}
                                  onChange={(date) => {
                                    var useTimeTo = getValues("useTimeTo");
                                    onChange(date);
                                    if (!useTimeTo || (date?.toDate && date?.toDate()?.getTime() > new Date(useTimeTo).getTime())) {
                                      // Set the value of useTimeTo to the same as useTimeOf
                                      setValue("useTimeTo", date);
                                    }
                                  }}
                                  placeholder="زمان انجام تفریح از"
                                />
                              )}
                            />
                          </Col>
                          <Col sm="6" xl="3" className="px-2 mb-1 mt-5">
                            <Controller
                              name="useTimeTo"
                              control={control}
                              render={({ field: { onChange, value } }) => (
                                <ShamsiDatePicker value={value} onChange={onChange} placeholder="زمان انجام تفریح تا" />
                              )}
                            />
                          </Col>

                          <Col sm="6" xl="3" className="px-2">
                            <Controller
                              name="basketItemPersonOf"
                              control={control}
                              render={({ field: { onChange, value } }) => (
                                <NumericFormat
                                  type="search"
                                  customInput={TextField}
                                  label="شماره بلیط از "
                                  size="small"
                                  className="mt-5"
                                  margin="normal"
                                  value={value || ""}
                                  variant="outlined"
                                  error={!!errors.basketItemPersonOf}
                                  onValueChange={(values) => {
                                    onChange(values.value || "");
                                    validateNumberBasketItemPersonOf(values.value);
                                  }}
                                  onKeyDown={(e) => {
                                    if (e.key === "Escape") {
                                      e.stopPropagation()
                                    }
                                  }}
                                />
                              )}
                            />
                            {errors.basketItemPersonOf && (
                              <div className="text-small-1 text-danger"> {errors.basketItemPersonOf.message}</div>
                            )}
                          </Col>
                          <Col sm="6" xl="3" className="px-2">
                            <Controller
                              name="basketItemPersonTo"
                              control={control}
                              render={({ field: { onChange, value } }) => (
                                <NumericFormat
                                  type="search"
                                  customInput={TextField}
                                  label="شماره بلیط تا "
                                  size="small"
                                  className="mt-5"
                                  margin="normal"
                                  value={value || ""}
                                  variant="outlined"
                                  error={!!errors.basketItemPersonTo}
                                  onValueChange={(values) => {
                                    onChange(values.value || "");
                                    validateNumberBasketItemPersonTo(values.value);
                                  }}
                                  onKeyDown={(e) => {
                                    if (e.key === "Escape") {
                                      e.stopPropagation()
                                    }
                                  }}
                                />
                              )}
                            />
                            {errors.basketItemPersonTo && (
                              <div className="text-small-1 text-danger"> {errors.basketItemPersonTo.message}</div>
                            )}
                          </Col>
                          <Col sm="6" xl="3" className="px-2">
                            <Controller
                              name="basketIdOf"
                              control={control}
                              render={({ field: { onChange, value } }) => (
                                <NumericFormat
                                  type="search"
                                  customInput={TextField}
                                  label="شماره سفارش از"
                                  className="mt-5"
                                  size="small"
                                  margin="normal"
                                  value={value || ""}
                                  variant="outlined"
                                  error={!!errors.basketIdOf}
                                  onValueChange={(values) => {
                                    onChange(values.value || "");
                                    validateNumberBasketIdOf(values.value);
                                  }}
                                  onKeyDown={(e) => {
                                    if (e.key === "Escape") {
                                      e.stopPropagation()
                                    }
                                  }}
                                />
                              )}
                            />
                            {errors.basketIdOf && (
                              <div className="text-small-1 text-danger"> {errors.basketIdOf.message}</div>
                            )}
                          </Col>
                          <Col sm="6" xl="3" className="px-2">
                            <Controller
                              name="basketIdTo"
                              control={control}
                              render={({ field: { onChange, value } }) => (
                                <NumericFormat
                                  type="search"
                                  customInput={TextField}
                                  className="mt-5"
                                  label="شماره سفارش تا"
                                  size="small"
                                  margin="normal"
                                  value={value || ""}
                                  variant="outlined"
                                  error={!!errors.basketIdTo}
                                  onValueChange={(values) => {
                                    onChange(values.value || "");
                                    validateNumberBasketIdTo(values.value);
                                  }}
                                  onKeyDown={(e) => {
                                    if (e.key === "Escape") {
                                      e.stopPropagation()
                                    }
                                  }}
                                />
                              )}
                            />
                            {errors.basketIdTo && (
                              <div className="text-small-1 text-danger"> {errors.basketIdTo.message}</div>
                            )}
                          </Col>

                          <Col sm="6" xl="3" className="px-2">
                            <Controller
                              name="firstName"
                              control={control}
                              render={({ field: { onChange, value } }) => (
                                <TextField
                                  label="نام"
                                  className="mt-3"
                                  margin="normal"
                                  variant="outlined"
                                  size="small"
                                  value={value || ""}
                                  onInput={onChange}
                                />
                              )}
                            />
                          </Col>
                          <Col sm="6" xl="3" className="px-2">
                            <Controller
                              name="lastName"
                              control={control}
                              render={({ field: { onChange, value } }) => (
                                <TextField
                                  className="mt-3"
                                  label="نام خانوادگی"
                                  margin="normal"
                                  variant="outlined"
                                  size="small"
                                  value={value || ""}
                                  onInput={onChange}
                                />
                              )}
                            />
                          </Col>
                          <Col sm="6" xl="3" className="px-2">
                            <Controller
                              name="phoneNumber"
                              control={control}
                              render={({ field: { onChange, value } }) => (
                                <NumericFormat
                                  className="mt-3"
                                  type="search"
                                  customInput={TextField}
                                  label="شماره موبایل"
                                  size="small"
                                  margin="normal"
                                  value={value || ""}
                                  variant="outlined"
                                  onChange={onChange}
                                  onKeyDown={(e) => {
                                    if (e.key === "Escape") {
                                      e.stopPropagation()
                                    }
                                  }}
                                />
                              )}
                            />
                          </Col>
                          <Col sm="6" xl="3" className="px-2">
                            <Controller
                              name="currentStatus"
                              control={control}
                              render={({ field }) => (
                                <SelectComponent
                                  placeholder="وضعیت سفارش"
                                  className="mt-3"
                                  options={[
                                    {
                                      value: "0,2",
                                      label: "0-جدید و 2-رهاسازی",
                                    },
                                    ...basketItemCurrentStatus
                                      .filter((item) => item.id != 0 && item.id != 2)
                                      .map((item) => ({
                                        value: item.id,
                                        label: item.id + "-" + item.title,
                                      })),
                                  ]}
                                  onChange={handleChangeMultiCurrentStatus}
                                  field={field}
                                  isMulti
                                />
                              )}
                            />
                          </Col>

                          <Col sm="6" xl="3" className="px-2">
                            <Controller
                              name="cancelStatus"
                              control={control}
                              rules={{}}
                              render={({ field }) => (
                                <SelectComponent
                                  placeholder="وضعیت کنسل"
                                  className="mt-3"
                                  options={basketCancelStatus?.map((item) => ({
                                    value: item.id,
                                    label: item.id + "-" + item.title,
                                  }))}
                                  field={field}
                                  onChange={handleChangeMultiCancelStatus}
                                  isMulti
                                />
                              )}
                            />
                          </Col>
                          <Col sm="6" xl="3" className="px-2">
                            <Controller
                              name="originalPrice"
                              control={control}
                              render={({ field: { onChange, value } }) => (
                                <NumericFormat
                                  customInput={TextField}
                                  label="نرخ مصوب "
                                  className="mt-3"
                                  size="small"
                                  type="search"
                                  margin="normal"
                                  value={value || ""}
                                  variant="outlined"
                                  thousandSeparator=","
                                  error={!!errors.originalPrice}
                                  onValueChange={(values) => {
                                    onChange(values.value || "");
                                    validateNumberOriginalPrice(values.value);
                                  }}
                                  onKeyDown={(e) => {
                                    if (e.key === "Escape") {
                                      e.stopPropagation()
                                    }
                                  }}
                                />
                              )}
                            />
                            {errors.originalPrice && (
                              <div className="text-small-1 text-danger"> {errors.originalPrice.message}</div>
                            )}
                          </Col>
                          <Col sm="6" xl="3" className="px-2">
                            <Controller
                              name="salePrice"
                              control={control}
                              render={({ field: { onChange, value } }) => (
                                <NumericFormat
                                  type="search"
                                  customInput={TextField}
                                  label="نرخ فروش "
                                  className="mt-3"
                                  size="small"
                                  margin="normal"
                                  value={value || ""}
                                  variant="outlined"
                                  thousandSeparator=","
                                  error={!!errors.salePrice}
                                  onValueChange={(values) => {
                                    onChange(values.value || "");
                                    validateNumberSalePrice(values.value);
                                  }}
                                  onKeyDown={(e) => {
                                    if (e.key === "Escape") {
                                      e.stopPropagation()
                                    }
                                  }}
                                />
                              )}
                            />
                            {errors.salePrice && (
                              <div className="text-small-1 text-danger"> {errors.salePrice.message}</div>
                            )}
                          </Col>
                          <Col sm="6" xl="3" className="px-2">
                            <Controller
                              name="cityIdList"
                              control={control}
                              render={({ field }) => (
                                <SelectComponent
                                  className="mt-3"
                                  placeholder="شهر"
                                  options={amusementCityList}
                                  isMulti
                                  field={field}
                                  onChange={(selectedCities) => {
                                    let confirmValues = selectedCities;
                                    if (selectedCities.find(item => item.value == 0)) {
                                      setIsSelectOtherCityElseKish(true)
                                      confirmValues = selectedCities.filter(city => city.value == 0)
                                    }
                                    else
                                      setIsSelectOtherCityElseKish(false)
                                    field.onChange(confirmValues)
                                  }}
                                />
                              )}
                            />
                          </Col>

                          <Col sm="6" xl="3" className="px-2">
                            <Controller
                              name="groupIdList"
                              control={control}
                              render={({ field }) => (
                                <SelectComponent
                                  className="mt-3"
                                  placeholder=" دسته تفریح"
                                  options={amusementGroupList?.map((item) => ({ value: item.id, label: item.title }))}
                                  isMulti
                                  field={field}
                                />
                              )}
                            />
                          </Col>
                          <Col sm="6" xl="3" className="px-2">
                            <Controller
                              name="amusementServiceIds"
                              control={control}
                              render={({ field }) => (
                                <SelectComponent
                                  className="mt-3"
                                  placeholder="تفریح"
                                  options={services?.map((item) => ({
                                    value: item.id,
                                    label: item.id + "-" + item.name,
                                  }))}
                                  field={field}
                                  onChange={(e) => inputChangeHandlerService(e)}
                                  isMulti
                                />
                              )}
                            />
                          </Col>
                          <Col sm="6" xl="3" className="px-2">
                            <Controller
                              name="amusementServiceReserveItemGroupIds"
                              control={control}
                              render={({ field }) => (
                                <SelectComponent
                                  className="w-20 mt-3"
                                  placeholder="گروه آیتم"
                                  options={groupedReserveItemsOptions || []}
                                  field={field}
                                  isMulti
                                />
                              )}
                            />
                          </Col>
                          <Col sm="6" xl="3" className="px-2">
                            <Controller
                              name="amusementServiceReserveItemIds"
                              control={control}
                              render={({ field }) => (
                                <SelectComponent
                                  className="w-20 mt-3"
                                  placeholder="آیتم"
                                  options={group || []}
                                  field={field}
                                  isMulti
                                />
                              )}
                            />
                          </Col>


                          <Col sm="6" xl="3" className="px-2">
                            <Controller
                              name="supplierIdList"
                              control={control}
                              render={({ field }) => (
                                <SelectComponent
                                  className="mt-5"
                                  placeholder="تامین کننده آیتم"
                                  options={suppliers?.map((item) => ({
                                    value: item.id,
                                    label: item.companyName,
                                  }))}
                                  isMulti
                                  field={field}
                                />
                              )}
                            />
                          </Col>
                          <Col sm="6" xl="3" className="px-2">
                            <Controller
                              name="promoCode"
                              control={control}
                              rules={{}}
                              render={({ field }) => (
                                <SelectComponent
                                  className="mt-5"
                                  placeholder="کد تخفیف"
                                  options={promoCodeEnumArray?.map((item) => ({
                                    value: item.id,
                                    label: item.title,
                                  }))}
                                  field={field}
                                />
                              )}
                            />
                          </Col>
                          <Col sm="6" xl="3" className="px-2">
                            <Controller
                              name="agentId"
                              control={control}
                              render={({ field }) => (
                                <SelectComponent
                                  className="w-20 mt-5"
                                  placeholder="نماینده فروش "
                                  options={agents?.map((item) => ({ value: item.id, label: item.companyName }))}
                                  field={field}
                                />
                              )}
                            />
                          </Col>
                          <Col sm="6" xl="3" className="px-2">
                            <Controller
                              name="commissionSettlementStatus"
                              control={control}
                              render={({ field }) => (
                                <SelectComponent
                                  className="mt-5"
                                  options={commissionSettlementStatus}
                                  placeholder="وضعیت کمیسیون نماینده "
                                  field={field}
                                />
                              )}
                            />
                          </Col>


                          <Col sm="6" xl="3" className="px-2">
                            <Controller
                              name="payToWarrantyCount"
                              control={control}
                              render={({ field }) => (
                                <SelectComponent
                                  className="mt-5"
                                  placeholder="پرداخت به تامین کننده"
                                  options={receiveOrPayToWarrantyEnumArray?.map(({ id: value, title: label }) => ({
                                    value,
                                    label,
                                  }))}
                                  field={field}
                                />
                              )}
                            />
                          </Col>
                          <Col sm="6" xl="3" className="px-2">
                            <Controller
                              name="receiveFromWarrantyCount"
                              control={control}
                              render={({ field }) => (
                                <SelectComponent
                                  className="mt-5"
                                  placeholder="دریافت از تامین کننده"
                                  options={receiveOrPayToWarrantyEnumArray?.map(({ id: value, title: label }) => ({
                                    value,
                                    label,
                                  }))}
                                  field={field}
                                />
                              )}
                            />
                          </Col>
                          <Col sm="6" xl="3" className="px-2">
                            <Controller
                              name="payOrReceiveWarrantyTimeOf"
                              control={control}
                              render={({ field: { onChange, value } }) => (
                                <ShamsiDatePicker
                                  className="mt-5"
                                  value={value}
                                  onChange={(date) => {
                                    var payOrReceiveWarrantyTimeTo = getValues("payOrReceiveWarrantyTimeTo");
                                    onChange(date);
                                    if (
                                      !payOrReceiveWarrantyTimeTo ||
                                      (date?.toDate && date?.toDate()?.getTime() > new Date(payOrReceiveWarrantyTimeTo).getTime())
                                    ) {
                                      // Set the value of payOrReceiveWarrantyTimeTo to the same as useTimeOf
                                      setValue("payOrReceiveWarrantyTimeTo", date);
                                    }
                                  }}
                                  placeholder="زمان پرداخت به تامین کننده از"
                                />
                              )}
                            />
                          </Col>
                          <Col sm="6" xl="3" className="px-2">
                            <Controller
                              name="payOrReceiveWarrantyTimeTo"
                              control={control}
                              render={({ field }) => (
                                <ShamsiDatePicker
                                  className="mt-5"
                                  {...field}
                                  placeholder="زمان پرداخت به تامین کننده تا"
                                />
                              )}
                            />
                          </Col>

                          <Col sm="6" xl="3" className="px-2">
                            <Controller
                              name="transactionSupplierIdList"
                              control={control}
                              render={({ field }) => (
                                <SelectComponent
                                  className="mt-5"
                                  placeholder="تامین کننده پرداخت شده"
                                  options={suppliers?.map((item) => ({
                                    value: item.id,
                                    label: item.companyName,
                                  }))}
                                  isMulti
                                  field={field}
                                />
                              )}
                            />
                          </Col>
                          <Col sm="6" xl="3" className="px-2">
                            <Controller
                              name="sortBy"
                              control={control}
                              render={({ field }) => (
                                <SelectComponent
                                  className="mt-5"
                                  placeholder="مرتب سازی بر اساس"
                                  options={sortOptions}
                                  field={field}
                                  noClear
                                />
                              )}
                            />
                          </Col>

                        </Row>

                        <Row className="mt-5">
                          <Col xs="12" className=" px-2 mt-3">
                            <Button
                              variant="success"
                              type="submit"
                              disabled={isSubmitting}

                            >
                              {(isSubmitting && !isExcel) && <Spinner animation="border" variant="warning" size="sm" />}
                              <SearchIcon />
                              جستجو
                            </Button>

                            <Button
                              className="ml-3"
                              variant="light-danger"
                              type="submit"
                              disabled={isSubmitting}
                              onClick={() => {
                                setIsSelectOtherCityElseKish(false)
                                tools.handleResetAdvanceSearchBox(watch, reset);
                              }}
                            >
                              {(isSubmitting && !isExcel) && <Spinner animation="border" variant="warning" size="sm" />}
                              <i className="fas fa-refresh text-small"></i>
                              حذف جستجو{" "}
                            </Button>
                            <Button
                              className="ml-2"
                              variant="info"
                              type="submit"
                              disabled={isSubmitting}
                              onClick={() => {
                                setIsExcel(true);
                              }}
                            >
                              {(isSubmitting && isExcel) && <Spinner animation="border" variant="warning" size="sm" />}
                              <InsertDriveFile /> فایل اکسل
                            </Button>
                          </Col>
                        </Row>
                      </Card.Body>
                    </Accordion.Body>
                  </Card>
                </Accordion>
                <InputGroup className="my-3">
                  <Controller
                    name="globalSearch"
                    control={control}
                    render={({ field: { onChange, value } }) => (
                      <GlobalFormControl
                        type="text"
                        aria-describedby="basic-addon1"
                        placeholder="جستجو ..."
                        name="globalSearch"
                        value={value || ""}
                        onChange={onChange}
                      />
                    )}
                  />

                  <Button variant="secondary" type="submit" disabled={isSubmitting}>
                    {isSubmitting && <Spinner animation="border" variant="warning" size="sm" />}
                    <SearchIcon />{" "}
                  </Button>
                </InputGroup>
              </div>

              {/* table */}
              <Col xs="12" className=" px-0">
                <DataGrid data={listData} />
              </Col>
            </form>
          </FormProvider>
        </div>
      </div>
    </div>
  );
};

export default SellReport;
